<template>
  <div v-bind:style="app.navbarExpanded? 'max-width: calc(99vw - 220px)': 'max-width: calc(99vw - 60px)'">
    <div v-loading="isLoading" element-loading-text="Đang chuẩn bị dữ liệu..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="#f5f5f5" style="overflow-y: auto; max-height: 100vh">
      <div class="d-flex p-3">
        <el-select v-model="selectedAccount" filterable default-first-option
                   placeholder="Tìm kiếm tài khoản..." size="sm" style="max-width: 450px" class="flex-1" multiple>
          <el-option v-for="account in accounts" :key="account.accountId" :label="getAccountName(account)"
                     :value="account.accountId">
          </el-option>
        </el-select>
        <el-select v-model="selectType" class="w-150px mx-2">
          <el-option v-for="item in types" :key="item.val" :label="item.name"
                     :value="item.val">
          </el-option>
        </el-select>
        <div>
          <el-button size="medium" @click="fetchStatistic()" type="primary">Tổng hợp</el-button>
        </div>
      </div>
      <div class="p-2">
        <div class="d-flex px-2 " style="height: 480px">
          <el-card class="flex-1">
            <div class="font-size-16 fw-semibold mb-1">Tỷ lệ theo tài khoản</div>
            <apexchart type="pie" height="380" :options="chartOptions_a" :series="series_a"></apexchart>
          </el-card>
          <div class="mx-1" />
          <el-card class="flex-1">
            <div class="font-size-16 fw-semibold mb-1">Tỷ lệ theo tag</div>
            <apexchart type="pie" height="380" :options="chartOptions_b" :series="series_b"></apexchart>
          </el-card>
        </div>
        <div>
          <el-card class="m-2 p-2 font-size-16">
            <el-table :data="data.rows" stripe fit show-header
                      style="min-height: 500px; max-height:  calc(100vh - 690px);overflow-y: auto">
              <el-table-column v-for="column in data.columns"
                               :key="column.field"
                               :prop="column.field"
                               :label="column.label"
                               :min-width="column.minWidth"
                               :align="column.align"
              >
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import "vue-good-table/dist/vue-good-table.css";

export default {
  name: "TagStatistical",
  data() {
    return {
      types: [
        { name: "Tất cả liên hệ", val: "all" },
        { name: "Cá nhân", val: "personal" },
        { name: "Nhóm", val: "group" },
        { name: "Zalo OA", val: "page" }
      ],
      data: {},
      selectType: "all",
      isLoading: false,
      accounts: [],
      selectedAccount: [],
      overviewId: "",
      tags: [],
      slider: {
        interval: 0,
        total: 0,
        index: 0
      },
      series_a: [],
      chartOptions_a: {
        labels: [],
        chart: {
          type: "donut"
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }]
      },
      series_b: [],
      chartOptions_b: {
        chart: {
          type: "donut"
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }]
      }
    };
  },
  methods: {
    tableRowStyle({ row }) {

      return "{color:" + row.color + "}";
    },
    getAccounts() {
      // this.$http.get("/api/account/getAll").then(resp => {
        this.accounts = this.app.accounts;
        this.$http.get("/api/tag").then((r) => {
          this.tags = r.data;
          this.fetchStatistic();
        });
      // });
    },
    getNameAcc(accountId) {
      let acc = this.accounts.find(s => s.accountId == accountId);
      return this.getAccountName(acc);
    },
    fetchStatistic() {
      this.overviewId = "Tag_Statistical_" + new Date().getTime();
      let accountIds = [];
      this.chartOptions_a.labels = [];
      this.chartOptions_b.labels = [];
      this.series_a = [];
      this.series_b = [];
      let tagIds = [];
      this.tags.forEach((t) => {
        tagIds.push(t.id);
      });
      if (this.selectedAccount.length == 0) {
        this.accounts.forEach((acc) => {
          accountIds.push(acc.accountId);
        });
      } else {
        accountIds.push(...this.selectedAccount);
      }
      if (accountIds.length > 0 && tagIds.length > 0) {
        this.isLoading = true;
        this.$http.post("/api/statistic/tag", {
          accountIds: accountIds,
          id: this.overviewId,
          type: this.selectType,
          tagIds: tagIds
        }).then(((res) => {
          let topAccount = res.data.topAccount;

          let labels = [];
          topAccount.forEach((t) => {
            if (t.accountId == "0") {
              labels.push("Khác");
              this.series_a.push(t.totalConversation);
            } else {
              let acc = this.accounts.find(s => s.accountId == t.accountId);
              this.series_a.push(t.totalConversation);
              labels.push(this.getAccountName(acc));
            }
          });
          this.chartOptions_a = {
            chart: {
              type: "donut",
              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: true,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                  customIcons: []
                },
                export: {
                  csv: {
                    filename: undefined,
                    columnDelimiter: ",",
                    headerCategory: "category",
                    headerValue: "value",
                    dateFormatter(timestamp) {
                      return new Date(timestamp).toDateString();
                    }
                  },
                  svg: {
                    filename: undefined
                  },
                  png: {
                    filename: undefined
                  }
                },
                autoSelected: "zoom"
              }
            },
            colors: this.getRandomColors(20),
            labels: labels,
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }]
          };
          let topTag = res.data.topTag;

          labels = [];
          topTag.forEach((t) => {
            if (t.tagId == 0) {
              labels.push("Khác");
              this.series_b.push(t.totalConversation);
            } else {
              let tag = this.tags.find(s => s.id == t.tagId);
              this.series_b.push(t.totalConversation);
              labels.push(tag.name);
            }
          });
          this.chartOptions_b = {
            chart: {
              type: "donut",
              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: true,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                  customIcons: []
                },
                export: {
                  csv: {
                    filename: undefined,
                    columnDelimiter: ",",
                    headerCategory: "category",
                    headerValue: "value",
                    dateFormatter(timestamp) {
                      return new Date(timestamp).toDateString();
                    }
                  },
                  svg: {
                    filename: undefined
                  },
                  png: {
                    filename: undefined
                  }
                },
                autoSelected: "zoom"
              }
            },
            colors: this.getRandomColors(20),
            labels: labels,
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }]
          };
          this.isLoading = false;
          this.data.columns = [];
          this.data.columns.push({ label: "Tag", field: "0", minWidth: "200px", fixed: true, align: "auto" });
          res.data.labels.forEach(l => {
            this.data.columns.push({
              label: this.getNameAcc(l),
              field: l,
              minWidth: "160px",
              fixed: false,
              align: "center"
            });
          });
          this.data.rows = [];
          res.data.series.forEach(s => {
            try {
              let row = {};
              let t = this.tags.find(ts => ts.id == s.tagId);
              row["0"] = t.name;
              s.data.forEach((sub, i) => {
                row[this.data.columns[i + 1].field] = sub;
              });
              row["color"] = t.color;
              this.data.rows.push(row);
            } catch (_) {
              //
            }
          });
        }));
      }
    },


    getHeightBarChar(labels) {
      return (60 * labels.length).toString();
    }
  },
  beforeDestroy() {
    this.$bus.$off("TagStatistical_event");
  },
  created() {
    this.$bus.$on("TagStatistical_event", (data) => {
      this.updateStatistic(data);
    });
    this.getAccounts();
  }
}
;
</script>

<style scoped>

</style>
